"use strict";

define('components/filter_bar/table/bulk_subscription_invite',['components/ajax'], function(ajax) {
    var bulkSubscriptionInviteComponent = {
        initWithContext: function(context) {
            var inviteButton = context.buttonbarNode.find('.selection-subscription-invite button');
            inviteButton.click(function() {
                inviteButton.addClass('disabled').prop('disabled', true);
                try {
                    var objectIds = context.tableFilterBarData.tableInstance.getSelectedObjectIds();

                    var formData = new FormData();
                    formData.append('prospect_ids', JSON.stringify(objectIds));
                    
                    ajax(inviteButton.data('url'), {
                        formData: formData
                    });
                } finally {
                    inviteButton.removeClass('disabled').prop('disabled', false);
                }
            });
        }
    };

    return bulkSubscriptionInviteComponent;
});

